// FIXME: redo the keys for the table.
/* eslint-disable react/no-array-index-key */

import React from 'react';

import Button from 'components/form/Button.component';
import { DOWNLOAD_EXCEL } from 'constants/csv.const';
import { exportCSV } from 'utils/converters/csv.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './ReportTableV2.module.scss';

class ReportTableV2 extends React.Component {
  static defaultProps = {
    children: [],
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderLeftHeaderTbl = () => {
    if (!this.props.data.leftHeader) {
      return null;
    }
    let defaultStyle = '';
    if (this.props.data.leftHeader.styles.length > 0) {
      if (this.props.data.leftHeader.styles.length === 1) {
        [defaultStyle] = this.props.data.leftHeader.styles;
      }
    }

    return (
      <>
        {this.props.children}
        <table className="table-reports first">
          <tbody>
            {this.props.data.leftHeader.inputFields.map((field, index) => (
              <tr key={createNodeKey({ index, tag: field })}>
                <td
                  className={
                    this.props.data.leftHeader && this.props.data.leftHeader.styles[index]
                      ? this.props.data.leftHeader.styles[index]
                      : defaultStyle
                  }
                >
                  {/* This tooltip  is visible only in Bookings by status table */}
                  <span className="bubble">
                    <span className="tooltip">
                      <div />
                    </span>
                  </span>
                  <div className="column-name">{field}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  };

  renderTopHeaderTbl = () => {
    if (!this.props.data.topHeader) {
      return null;
    }
    let defaultStyle = '';
    if (this.props.data.topHeader.styles.length > 0) {
      if (this.props.data.topHeader.styles.length === 1) {
        [defaultStyle] = this.props.data.topHeader.styles;
      }
    }

    return (
      <tr className="thead">
        {this.props.data.topHeader.inputFields.map((field, i) => (
          <td
            style={{ width: '121px', height: '57px' }}
            key={`${field}+${i}`}
            className={
              this.props.data.topHeader && this.props.data.topHeader.styles[i]
                ? this.props.data.topHeader.styles[i]
                : defaultStyle
            }
          >
            <span className="bubble">
              <span className="tooltip">
                <div />
              </span>
            </span>
            <span className="column-title"> {field}</span>
          </td>
        ))}
        <th className="last-empty" style={{ width: 'auto' }} />
      </tr>
    );
  };

  createCSV = (data) => {
    if (!data) return [];

    const topHeaders = data?.topHeader?.inputFields;
    const leftHeaders = data?.leftHeader?.inputFields;
    const content = data?.rows;

    if (!Array.isArray(leftHeaders) || leftHeaders.length === 0) {
      return [];
    }

    if (!Array.isArray(content) || content.length === 0) {
      return [];
    }

    const fallbackHeader = isFullArray(topHeaders)
      ? topHeaders
      : Array.isArray(content[0]?.inputFields)
        ? content[0].inputFields
        : [];

    const headers = [leftHeaders[0], ...fallbackHeader];

    const rowsData = isFullArray(topHeaders) ? content : content.slice(1);
    const rows = rowsData.map((row, index) => {
      const label = leftHeaders[index + 1] || '';

      const inputFields = Array.isArray(row?.inputFields) ? row.inputFields : [];

      return [label, ...inputFields];
    });

    const csv = rows.map((row) =>
      headers.reduce((obj, key, index) => {
        obj[key] = row[index] !== undefined ? row[index] : '';
        return obj;
      }, {}),
    );

    return csv;
  };

  handleExportCsv = (options) => {
    const { data, fileName } = options;

    const csvData = this.createCSV(data);

    exportCSV({ data: csvData, fileName });
  };

  render() {
    const leftHeaderTbl = this.renderLeftHeaderTbl();
    const topHeaderTbl = this.renderTopHeaderTbl();
    const tableId = this.props.title; // .split(' ').join('').toString();
    const hasTableData = fromAnyToBool(this.props.data.rows.length);

    return (
      <>
        <div className="t-bgr cfix">
          <div className="t-wrap">
            <div className={CN.downloadButton}>
              <Button
                variant="primaryForce"
                onClick={() => this.handleExportCsv({ data: this.props.data, fileName: tableId })}
                disabled={!hasTableData}
                width="small"
                height="xs"
              >
                <span className={CN.buttonFont}>{DOWNLOAD_EXCEL}</span>
              </Button>
            </div>
            {this.props.title && <h2>{this.props.title}</h2>}
            <div>
              <table style={{ width: '100%' }} id={tableId}>
                <tbody>
                  <tr>
                    <td colSpan="3">
                      <div className="date-in-tbl-for-export">
                        From <strong>{this.props.startDate}</strong> to <strong>{this.props.endDate}</strong>{' '}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: '168px' }} className="v2-first-column">
                      {leftHeaderTbl}
                    </td>
                    <td>
                      <table className="table-reports second">
                        <tbody className=" ">
                          {topHeaderTbl}
                          {this.props.data.rows.map((row, ind) => {
                            let defaultStyle = '';
                            if (row.styles.length > 0) {
                              if (row.styles.length === 1) {
                                [defaultStyle] = row.styles;
                              }
                            }
                            return (
                              <tr className="" key={`${row.inputFields.toString()}_${ind}`}>
                                {row.inputFields.map((field, i) => (
                                  <td
                                    style={{ width: '121px' }}
                                    key={`${field}+${i}`}
                                    className={row.styles[i] ? `${row.styles[i]}t-cell` : `${defaultStyle} t-cell`}
                                  >
                                    <div> {field}</div>
                                  </td>
                                ))}
                                <td className="last-empty-cell" style={{ width: 'auto' }} />
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ReportTableV2;
